import { MessageCircle, ArrowRight } from "lucide-react";
import { WA_MESSAGES, waLink } from "./data";

const WhatsAppFloat = () => (
  <>
    {/* Desktop floating button */}
    <a
      href={waLink(WA_MESSAGES.talk)}
      target="_blank"
      rel="noreferrer"
      className="group fixed bottom-8 right-8 z-[110] hidden h-13 items-center gap-0 overflow-hidden rounded-full border border-champagne/50 bg-obsidian/85 p-3.5 backdrop-blur-md transition-colors duration-500 hover:border-champagne md:flex"
      data-testid="whatsapp-float"
      aria-label="Talk to Elevate on WhatsApp"
    >
      <MessageCircle size={20} className="shrink-0 text-champagne" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-[11px] font-medium uppercase tracking-[0.22em] text-ivory transition-all duration-500 group-hover:ml-3 group-hover:max-w-[160px]">
        Talk to Elevate
      </span>
    </a>

    {/* Mobile sticky CTA */}
    <div className="fixed inset-x-0 bottom-0 z-[110] border-t border-ivory/10 bg-obsidian/90 p-3 backdrop-blur-md md:hidden">
      <a
        href={waLink(WA_MESSAGES.talk)}
        target="_blank"
        rel="noreferrer"
        className="flex w-full items-center justify-center gap-2 bg-champagne py-3.5 text-[12px] font-medium uppercase tracking-[0.22em] text-obsidian"
        data-testid="whatsapp-sticky-mobile"
      >
        WhatsApp Elevate <ArrowRight size={14} />
      </a>
    </div>
  </>
);

export default WhatsAppFloat;
